import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/recruiting-hiring-criteria-categories/profile/loading';

export const Route = createFileRoute('/_private/settings/recruiting-hiring-criteria-categories/$id')({
  pendingComponent: Loading,
});
